/**
 * Board-level purpose vs active Do-next step.
 * contextRecommendations.stepCandidates (was goalCandidates) — coach-proposed steps.
 * Nested stepCandidates[].goal / goalHistory[].goal are step titles — do not rename.
 */

export function readBoardGoal(boardOrCtx) {
  if (!boardOrCtx || typeof boardOrCtx !== 'object') return '';
  const next = boardOrCtx.boardGoal;
  if (next != null && String(next) !== '') return String(next);
  if (boardOrCtx.description != null) return String(boardOrCtx.description);
  return String(next || '');
}

export function readCurrentStep(boardOrCtx) {
  if (!boardOrCtx || typeof boardOrCtx !== 'object') return '';
  const next = boardOrCtx.currentStep;
  if (next != null && String(next) !== '') return String(next);
  if (boardOrCtx.goal != null) return String(boardOrCtx.goal);
  return String(next || '');
}

export function readFingerprintBoardGoal(fp) {
  if (!fp || typeof fp !== 'object') return '';
  if (fp.boardGoal != null && String(fp.boardGoal) !== '') return String(fp.boardGoal);
  return String(fp.description || '');
}

export function readFingerprintCurrentStep(fp) {
  if (!fp || typeof fp !== 'object') return '';
  if (fp.currentStep != null && String(fp.currentStep) !== '') return String(fp.currentStep);
  return String(fp.goal || '');
}

export function normalizeBoardGoalFields(board) {
  if (!board || typeof board !== 'object') return board;
  const next = {
    ...board,
    boardGoal: readBoardGoal(board),
    currentStep: readCurrentStep(board),
  };
  const recs = board.contextRecommendations;
  if (recs && typeof recs === 'object' && !Array.isArray(recs.stepCandidates) && Array.isArray(recs.goalCandidates)) {
    const { goalCandidates, ...rest } = recs;
    next.contextRecommendations = { ...rest, stepCandidates: goalCandidates };
  }
  return next;
}

/** Commit a saved board goal without keeping a legacy description that can resurrect it. */
export function boardWithSavedGoal(board, boardGoal) {
  const next = {
    ...(board && typeof board === 'object' ? board : {}),
    boardGoal: String(boardGoal ?? ''),
  };
  delete next.description;
  return next;
}
